import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f77a9f7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "weather"
};
const _hoisted_2 = {
  class: "weather-warning",
  "element-loading-background": "transparent"
};
const _hoisted_3 = {
  class: "scroll"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "right-cont"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "sub-title1"
};
const _hoisted_8 = {
  class: "sub-title2"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "right-cont"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = {
  class: "sub-title1"
};
const _hoisted_13 = {
  class: "sub-title2"
};
const _hoisted_14 = {
  class: "bottom-font"
};
const _hoisted_15 = {
  id: "scoll1"
};
const _hoisted_16 = {
  id: "scoll2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.chartData, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "data-box",
      key: index
    }, [_createElementVNode("img", {
      src: require('../../assets/images/weather/' + $options.tianqiIconComputed(item.skycon) + '.png'),
      alt: "",
      class: "icon"
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.recordTime), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.temperatureMin + "℃" + "~" + item.temperatureMax + "℃"), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(item.windDirectionMin + item.windScaleMin), 1)])]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.chartData, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "data-box",
      key: index
    }, [_createElementVNode("img", {
      src: require('../../assets/images/weather/' + $options.tianqiIconComputed(item.skycon) + '.png'),
      alt: "",
      class: "icon"
    }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(item.recordTime), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(item.temperatureMin + "℃" + "~" + item.temperatureMax + "℃"), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.windDirectionMin + item.windScaleMin), 1)])]);
  }), 128))])])), [[_directive_loading, $data.loading]]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString($data.weatherContent) + " ", 1)])])]);
}